
import "@sparta.auto-loans.modules/payment-calc-auto-module/dist/styles.css"
import "@sparta.auto-loans.modules/car-shop-with-confidence-module/dist/styles.css"
import "@sparta.auto-loans.modules/calc-learning-auto-module/dist/styles.css"


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"
import ampTriggerVideoUtility from "@sparta.global.utilities/amp-trigger-video-utility/dist/es6.js"
import secureLinkUtility from "@sparta.global.utilities/secure-link-utility/dist/es6.js"
import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es6.js"
import spartaRegisterSwUtility from "@sparta.global.utilities/sparta-register-sw-utility/dist/es6.js"
import cspStyleBinder from "@sparta.sales.utilities/csp-style-binder/dist/es6.js"

import "@sparta.auto-loans.modules/payment-calc-auto-module/dist/es6.js"
import "@sparta.auto-loans.modules/car-shop-with-confidence-module/dist/es6.js"
import "@sparta.auto-loans.modules/calc-learning-auto-module/dist/es6.js"


window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [

  ],
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(async function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  secureLinkUtility.run()
await spartaBootstrapUtility.init(arguments);
spartaRegisterSwUtility.init();
cspStyleBinder.bindStyle();
  console.log('after - execute boot functions')
})();
